<template>
<div>
  <div class="card">
    <div class="card-header">
      <p-button type="default" link style="float: left;" @click="navigateBack()" class="mt-0" title="Zurück"><i class="bi bi-arrow-left" style="font-size: 16px;"></i></p-button><h3 class="title mb-1"><b>Neuer Mitarbeiter</b></h3>
    </div>
    <div class="card-body">
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Vor- und Nachname"
                      v-model="trainerName">
            </fg-input>
          </div>
          <div class="col-md-6">
          </div>
        </div>
          <h5 class="pt-4">Kontaktdaten</h5>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Telefon"
                      v-model="trainerTelefon">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="email"
                      label="E-Mail"
                      v-model="trainerMail">
            </fg-input>
          </div>
        </div>
        <h5 class="pt-4">Notfallkontakt</h5>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Name Notfallkontakt"
                      v-model="trainerNotfallkontaktName">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Telefon Notfallkontakt"
                      v-model="trainerNotfallkontaktNummer">
            </fg-input>
          </div>
        </div>
        <h5 class="pt-4">Vertragsdaten</h5>
        <div class="row">
          <div class="col-md-3">
            <label>Wochenstunden</label><br>
            <el-input-number v-model="trainerWochenstunden" :min="0" :max="60"></el-input-number>
          </div>
          <div class="col-md-3">
            <label>Urlaubstage</label><br>
            <el-input-number v-model="trainerUrlaubstage" :min="0" :max="50"></el-input-number>
          </div>
          <div class="col-md-6">
            <label>Letzter Erste-Hilfe-Kurs</label><br>
            <el-date-picker
              v-model="trainerErsteHilefeKursDatum"
              type="month"
              placeholder="Monat wählen"
              format="MM/yyyy"
              :picker-options="pickerOptions1">
            </el-date-picker>
          </div>
        </div>
        <div class="row pb-4">
          <div class="col-md-12">
        <h5 class="pt-4">Arbeitsbereiche</h5>
        <div class="row">
          <div class="col-md-3">
            <p-switch v-model="trainerIsEinweiser" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Betreuer
          </div>
          <div class="col-md-3">
              <p-switch v-model="trainerIsRetter" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Retter
          </div>

          <div class="col-md-3">
            <p-switch v-model="trainerIsKasse" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Kasse
          </div>
          <div class="col-md-3">
              <p-switch v-model="trainerIsHT" type="primary">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
            </p-switch> Haupttrainer
          </div>
        </div>
          </div>
        </div>

        <div class="text-right pt-3">
          <button type="reset" class="btn btn-warning btn-fill btn-wd" @click.prevent="onCancel">
            Abbrechen
          </button>
          <button type="submit" class="btn btn-success btn-fill btn-wd" @click.prevent="createTrainer" :disabled="trainerName == ''">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>

</div>
</template>
<script>
  import Vue from 'vue'
  import { db, fc } from '../../../../firebaseDb'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import router from '../../../../main'
  import store from "../../../../store";
  import { Input, Loading, InputNumber, MessageBox } from "element-ui";
  import { httpsCallable } from "firebase/functions";
import { remove } from 'nprogress';

  export default {
    components: {
        PSwitch,
        [Input.name]: Input,
        [InputNumber.name]: InputNumber,
        MessageBox,
    },

    data () {
      return {
          trainerDocID: 0,
          trainerName: "",
          trainerTelefon: "",
          trainerMail: "",
          trainerNotfallkontaktNummer: "",
          trainerNotfallkontaktName: "",
          trainerWochenstunden: 0,
          trainerUrlaubstage: 0,
          trainerErsteHilefeKursDatum: "",
          trainerIsRetter: false,
          trainerIsHT: false,
          trainerIsKasse: false,
          trainerIsEinweiser: false,
          trainerIsVA: false,
          trainerIsRetterBefore: false,
          trainerIsHTBefore: false,
          trainerIsKasseBefore: false,
          trainerIsVABefore: false,
          location: store.getters.userlocation,
          pickerOptions1: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
            firstDayOfWeek: 1,
            shortcuts: [],
          },
      }
    },
    created () {
    },
    methods: {
        onCancel () {
            router.push({ name: 'Trainer'})
        },
        createTrainer () {
            let ersteHilfe = null
            if(this.trainerErsteHilefeKursDatum) {
              ersteHilfe = this.trainerErsteHilefeKursDatum
            } else {
              ersteHilfe = new Date('1970-01-01')
            }
            const trainerRef = db.collection('trainer')
            trainerRef.add({ Name: this.trainerName, Telefon: this.trainerTelefon, Mail: this.trainerMail, NotfallkontaktName: this.trainerNotfallkontaktName, NotfallkontaktNummer: this.trainerNotfallkontaktNummer, Wochenstunden: this.trainerWochenstunden, Urlaubstage: this.trainerUrlaubstage, ErsteHilfeKursDatum: ersteHilfe, isEinweiser: this.trainerIsEinweiser, isRetter: this.trainerIsRetter, isKasse: this.trainerIsKasse, isHT: this.trainerIsHT, isVA: this.trainerIsVA, locationID: [this.location] }).then(() => {
                router.push({ name: 'Trainer'})
            }).catch((error) => {
                console.log('Fehler beim Anlegen des Mitarbeiters: ' + error)
            })
        },
        navigateBack() {
          router.go(-1);
        },
    }
  }

</script>
<style>

</style>
